// export const HourlyData = {
//     "leaveid": null,
//     "parentid": null,
//     "leavetypeid": 3,
//     "leavecategoryid": 1,
//     "leavename": "My houlry Policy",
//     "description": "My houlry Policy",
//     "employeetypeids": null,
//     "maxmonthhour": "00:00",
//     "maxonedayhour":"00:00",
//     "minhour": "00:00",
//     "isprorate": true,
//     "proratetypeid": 1,
//     "creditmodetypeid": 1,
//     "midjoinstartday": null,
//     "isextentionprobation": true,
//     "creditdaymonth": null,
//     "othercreditmodetypeid": 1,
//     "accuralfrequencytype": 1,
//     "isfurtureappallowed": true,
//     "minleavecountforapp": 0,
//     "notifyinadvanceday": 0,
//     "notifynotbeforeday": 0,
//     "ispastappallowed": false,
//     "apppastday": 0,
//     "isoverutilizationallowed": null,
//     "iscarryforwardallowed": null,
//     "forwardtypeid": null,
//     "carryforwardunusedperc": 0,
//     "carryforwardunused": 0,
//     "datastate": 1
// }


export const HourlyData = {
  leaveid: null,
  parentid: null,
  leavetypeid: 3,
  leavecategoryid: 1,
  leavename: null,
  description: null,
  maxmonthhour: 1,
  maxonedayhour: 1,
  minhour: 0,
  isprorate: true,
  proratetypeid: 1,
  creditmodetypeid: 1,
  midjoinstartday: 0,
  isextentionprobation: true,
  creditdaymonth: null,
  othercreditmodetypeid: 1,
  accuralfrequencytype: 1,
  isfurtureappallowed: true,
  // "minleavecountforapp": 0,
  // "notifyinadvanceday": 0,
  // "notifynotbeforeday": 0,
  ispastappallowed: true,
  apppastday: 0,
  isoverutilizationallowed: false,
  iscarryforwardallowed: false,
  forwardtypeid: null,
  carryforwardunusedperc: 0,
  carryforwardunused: 0,
  approvaltypeid: 1,
  datastate: 1,
};
